import { render, staticRenderFns } from "./xuqiuItem.vue?vue&type=template&id=69902230&scoped=true&"
import script from "./xuqiuItem.vue?vue&type=script&lang=js&"
export * from "./xuqiuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69902230",
  null
  
)

export default component.exports